import { render, staticRenderFns } from "./medkon_tren_media_konvensional.vue?vue&type=template&id=19bf7d3c&scoped=true"
import script from "./medkon_tren_media_konvensional.vue?vue&type=script&lang=js"
export * from "./medkon_tren_media_konvensional.vue?vue&type=script&lang=js"
import style0 from "./medkon_tren_media_konvensional.vue?vue&type=style&index=0&id=19bf7d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf7d3c",
  null
  
)

export default component.exports